import { createJSONRequest } from '../../../api/create-request.js'

export const fetchChatbotWidgets = () => {
  return createJSONRequest({
    method: 'GET',
    url: '/api/settings/chatbot-widgets',
  })
}

export const fetchChatbotWidget = (id: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/chatbot-widgets/${id}`,
  })
}

export const createChatbotWidget = (data: object) => {
  return createJSONRequest({
    method: 'POST',
    url: '/api/settings/chatbot-widgets',
    data,
  })
}

export const updateChatbotWidget = (id: number, data: object) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/chatbot-widgets/${id}`,
    data,
  })
}

export const deleteChatbotWidget = (id: number) => {
  return createJSONRequest({
    method: 'DELETE',
    url: `/api/settings/chatbot-widgets/${id}`,
  })
}

export const updateChatbotWidgetStatus = (id: number, status: string) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/chatbot-widgets/${id}/status`,
    data: { status },
  })
}
